import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { SignIn } from './SignIn';
import './ProtectedRoute.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, loading, user, signOut } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SignIn />;
  }

  if (!isAdmin) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-content">
          <div className="access-denied-icon">🚫</div>
          <h2>Access Denied</h2>
          <p>You don't have permission to access this admin portal.</p>
          <p>Only users in the <strong>admin</strong> group can access this application.</p>
          <div className="user-info">
            <p><strong>Current User:</strong> {user?.username}</p>
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Groups:</strong> {user?.groups?.length ? user.groups.join(', ') : 'None'}</p>
          </div>
          <button 
            className="sign-out-button"
            onClick={signOut}
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
